<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("user settings") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("default language") }}</label>
                <div class="control">
                  <div class="select">
                    <select v-model="meta.default_language">
                      <option value="es">{{ $t("spanish") }}</option>
                      <option value="en">{{ $t("english") }}</option>
                      <option value="fr">{{ $t("french") }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("default theme") }}</label>
                <div class="control">
                  <div class="select">
                    <select v-model="meta.default_theme">
                      <option value="dark">{{ "System Dark" }}</option>
                      <option value="light">{{ "System Light" }}</option>
                      <option value="cerulean">{{ "Cerulean" }}</option>
                      <option value="cosmo">{{ "Cosmo" }}</option>
                      <option value="cyborg">{{ "Cyborg" }}</option>
                      <option value="darkly">{{ "Darkly" }}</option>
                      <option value="flatly">{{ "Flatly" }}</option>
                      <option value="journal">{{ "Journal" }}</option>
                      <option value="litera">{{ "Litera" }}</option>
                      <option value="lumen">{{ "Lumen" }}</option>
                      <option value="lux">{{ "Lux" }}</option>
                      <option value="materia">{{ "Materia" }}</option>
                      <option value="minty">{{ "Minty" }}</option>
                      <option value="pulse">{{ "Pulse" }}</option>
                      <option value="sandstone">{{ "Sandstone" }}</option>
                      <option value="simplex">{{ "Simplex" }}</option>
                      <option value="slate">{{ "Slate" }}</option>
                      <option value="solar">{{ "Solar" }}</option>
                      <option value="spacelab">{{ "Spacelab" }}</option>
                      <option value="superhero">{{ "Superhero" }}</option>
                      <option value="united">{{ "United" }}</option>
                      <option value="yeti">{{ "Yeti" }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("options") }}</label>
                <div class="button is-info is-rounded" @click="test_theme">
                  <span class="icon">
                    <i class="fa fa-bolt"></i>
                  </span>
                  <span>{{ $t("test theme") }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <!-- <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('assistant')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/assistant/personality/catalog"
                  name_field="name"
                  value_field="uuid"
                  @selected="personality_changed"
                  ref="personality_dropdown"
                />
              </div>
            </div> -->
            <div class="column">
              <div class="field">
                <label class="label">
                  {{ $t("api key for assistant sdk") }}
                </label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :placeholder="$t('api key')"
                    v-model="meta.assistant_sdk_api_key"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
      <div class="notification is-danger mt-5" v-if="error">
        <p v-html="error"></p>
      </div>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button class="button is-primary is-rounded" @click="save">
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            {{ $t("cancel") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
import { put, get, generate_error_message_text, get_user_data } from "@/utils";
// import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  components: {
    // GenericDropdown,
  },
  name: "UserSettingsModal",
  data() {
    return {
      is_shown: false,
      error: "",
      meta: {},
    };
  },
  computed: {},
  methods: {
    close_modal() {
      let v = this;
      v.is_shown = false;
    },
    show_modal() {
      let v = this;
      v.error = "";
      v.is_shown = true;
      // v.$refs.personality_dropdown.clear();

      get("/system/user/settings")
        .then((settings) => {
          v.meta = settings;

          // if (settings.assistant_personality_uuid)
          //   v.$refs.personality_dropdown.set_value(
          //     settings.assistant_personality_uuid
          //   );
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    personality_changed(personality) {
      let v = this;
      if (personality) {
        v.meta.assistant_personality_uuid = personality.uuid;
      }
    },
    save() {
      let v = this;
      put("/system/user/settings", v.meta)
        .then(() => {
          let usrdta = get_user_data();
          if (
            usrdta &&
            usrdta.settings &&
            usrdta.settings.default_theme &&
            usrdta.settings.default_theme !== v.meta.default_theme
          ) {
            usrdta.settings.default_theme = v.meta.default_theme;
            localStorage.setItem("user_data", JSON.stringify(usrdta));
            location.reload();
          } else v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    test_theme() {
      // let v = this;
      let usrdta = get_user_data();
      usrdta.settings.default_theme = this.meta.default_theme;
      localStorage.setItem("user_data", JSON.stringify(usrdta));
      location.reload();
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
